import { Link, useLocation } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";

const navLinks = [
  { path: "/", label: "首页", icon: "ri-home-line" },
  { path: "/category/action", label: "分类", icon: "ri-grid-line" },
  { path: "/about", label: "关于我们", icon: "ri-information-line" },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    if (path === "/about") return location.pathname === "/about";
    if (path.startsWith("/category")) return location.pathname.startsWith("/category");
    return false;
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-100/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group whitespace-nowrap"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-background-50 text-lg"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-950 tracking-wide">
              天堂影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? "bg-primary-500/15 text-primary-600"
                    : "text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-500 hover:text-foreground-900 hover:bg-background-200/70 transition-all duration-200 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200/70 transition-all duration-200 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          mobileOpen ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-4 pb-4 bg-background-100/95 backdrop-blur-md space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                isActive(link.path)
                  ? "bg-primary-500/15 text-primary-600"
                  : "text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70"
              }`}
            >
              <i className={`${link.icon} text-base`}></i>
              {link.label}
            </Link>
          ))}
          <div className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-foreground-500 hover:text-foreground-900 hover:bg-background-200/70 transition-all duration-200 cursor-pointer">
            <i className="ri-search-line text-base"></i>
            搜索电影
          </div>
        </div>
      </div>
    </nav>
  );
}